export interface TimelineNode {
  id: string;
  date: string;
  stage: string;
  title: string;
  summary: string;
  tag: string;
  verified: string;
}

export const timelineNodes: TimelineNode[] = [
  {
    id: 't1',
    date: '2024.03',
    stage: '酝酿期',
    title: '事件线索初次浮出水面',
    summary: '多位网友在同一时段发布零散线索，涉及同一场公共事件的初步描述。相关话题开始在小范围内被讨论，但尚未形成完整脉络。',
    tag: '发酵',
    verified: '待核实',
  },
  {
    id: 't2',
    date: '2024.04',
    stage: '升温期',
    title: '话题冲上社交平台热榜',
    summary: '随着更多现场细节与截图被陆续公开，事件讨论量快速上升，相关话题多次登上平台热榜前列，围观讨论进入白热化阶段。',
    tag: '热点',
    verified: '多方佐证',
  },
  {
    id: 't3',
    date: '2024.05',
    stage: '各方发声',
    title: '多方陆续作出公开回应',
    summary: '事件相关方通过不同渠道作出回应，不同说法之间出现出入。围绕时间先后、关键细节与责任归属的争议开始集中爆发。',
    tag: '争辩',
    verified: '存有分歧',
  },
  {
    id: 't4',
    date: '2024.06',
    stage: '真相梳理',
    title: '权威渠道发布核实信息',
    summary: '相关平台与机构介入核查，陆续发布官方说明，对部分传闻进行澄清。可信度较高的信息与猜测逐步被区分开来。',
    tag: '澄清',
    verified: '官方发布',
  },
  {
    id: 't5',
    date: '2024.08',
    stage: '后续观察',
    title: '事件进入长尾讨论阶段',
    summary: '热度虽有所回落，但有关事件后续进展与影响的分析仍在持续。碎片化信息逐步沉淀为可供回溯的完整时间线。',
    tag: '长尾',
    verified: '持续更新',
  },
  {
    id: 't6',
    date: '2025.02',
    stage: '现状追踪',
    title: '关注仍在持续并不断补全',
    summary: '我们持续跟踪相关动态，对新增公开信息进行去重、排序与交叉比对，确保时间线始终贴近事件真实走向。',
    tag: '进行中',
    verified: '持续更新',
  },
];